import { InputAdornment, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TbSearch } from "react-icons/tb";

export const WelcomeTeamTitle = ({ search, setSearch }: { search: string; setSearch: (value: string) => void }) => {
    const { t } = useTranslation();

    return (
        <TextField
            fullWidth
            placeholder={t("welcome_team_filter")}
            variant="standard"
            sx={{ fontWeight: 100 }}
            className="ml-3"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <TbSearch size={20} />
                    </InputAdornment>
                ),
            }}
        />
    );
};
